module.exports = __webpack_public_path__ + "static/media/contact-background.b1cc7972.png";